import { useCallback } from "react";
import { axiosStructurePartner } from "./axios";

export interface IVerifyStructurePartnersParams {
  partnerName: string;
  place?: string;
  excludeId?: string;
}

export type TVerifyStructurePartnersResponse = {
  name: string;
  place?: string;
}[];

export const useVerifyStructurePartners = () => {
  const [state, execute, cancel] = axiosStructurePartner<
    TVerifyStructurePartnersResponse,
    IVerifyStructurePartnersParams,
    unknown
  >(
    {
      url: "/verify",
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (params: IVerifyStructurePartnersParams) => {
      return execute({
        params,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
